import { Route } from '@angular/router';
import { SearchComponent } from './components/search/search.component';

export const SEARCH_ROUTES: Route[] = [
  {
    path: '',
    component: SearchComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
